angular.module('rjmNg.controllers').controller('defaultDashCtrl', [
  "$scope"
  "$modal"
  "$http"
  "dashboardService"
  "app"
  "$url"
  ($scope, $modal, $http, dashboardService, app, $url) ->
  
    $scope.makeDefaultDashboard = (modal) ->
      $http(
        method: 'POST'
        url: $url("/client/" + app.getClientId() + "/dashboard/" + $scope.dashboard.id + "/makeDefault/")
      )
      .then( ({data}) =>
        app.setDefaultDashboard($scope.dashboard.id)
        dashboardService.updateGlobalSearch()
        modal('hide')
      )  
])
